<template>
  <el-dialog
    :append-to-body="true"
    title="Форма перевыставления актов"
    :visible="visible"
    :width="isMobile ? '95%' : '90%'"
    :close-on-click-modal="false"
    @close="overAktsVisClose"
  >
    <h3 v-if="!result">Выберите отчет экспедитора сформированный 1С, не zip</h3>
    <el-upload
      ref="upload"
      :auto-upload="false"
      :http-request="customUpload"
      action=""
    >
      <el-button slot="trigger" size="small" type="primary">
        Выберите файл
      </el-button>
      <el-button
        style="margin-left: 10px"
        size="small"
        type="success"
        @click="submitOverAktsResult"
      >
        Разобрать файл
      </el-button>
    </el-upload>
    <div>
      <div v-if="overAktsVisResult.length > 0">
        <el-row :gutter="30">
          <el-col :span="3">
            <b>Номер отчета с датой:</b>
          </el-col>
          <el-col :span="5">
            <el-input v-model="overAktsNumOtch" size="mini" />
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-if="overAktsVisResult.length > 0">
      <el-row
        v-for="(res, i) in overAktsVisResult"
        :key="i"
        class="border-row"
        :gutter="25"
      >
        <el-col :span="1">{{ i + 1 }}</el-col>
        <el-col :span="4">{{ res.akt_title }}</el-col>
        <el-col :span="3">{{ res.cargo_total_price }}</el-col>
        <el-col :span="7">{{ res.job_description }}</el-col>
        <el-col :span="3">{{ res.price_by_text }}</el-col>
        <el-col :span="3">{{ res.service_name }}</el-col>
        <el-col :span="2">
          <el-input v-model="overAktsVisResult[i].ttn_num" size="mini" />
        </el-col>
      </el-row>
      <el-button type="primary" @click="saveAktsZip">
        Сохранить в архиве
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import Repository from '@/api/Repository'

export default {
  name: 'OverAktsVisModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      overAktsVisResult: [],
      overAktsNumOtch: '',
    }
  },
  methods: {
    overAktsVisClose() {
      this.$emit('close')
      this.overAktsVisResult = []
    },
    customUpload(file) {
      let param = new FormData()

      param.append('file', file.file)
      Repository.post('/txt-builder/otchet-to-data', param, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(res => this.doOverAktsResult(res))
        .catch(() => {})
    },
    submitOverAktsResult() {
      this.$refs.upload.submit()
    },
    doOverAktsResult(response) {
      this.overAktsVisResult = response.data
    },
    saveAktsZip() {
      let extBuf = { responseType: 'arraybuffer' }

      for (let i in this.overAktsVisResult) {
        this.overAktsVisResult[i].foundation_text = this.overAktsNumOtch
      }
      Repository.post(
        '/excel-builder/zip/akts',
        {
          data: this.overAktsVisResult,
        },
        extBuf,
      )
        .then(res => this.forceFileDownload(res, 'перевыставленные акты.zip'))
        .catch(() => {})
    },
  },
}
</script>

<style lang="sass">
.border-row
  padding-top: 10px
  border-bottom: 1px solid grey
</style>
